import { FC } from "react";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { getCurrentUser } from "../../store/authSlice";
import getInitialsName from "../../utils/getInitialsName";
import UserLogoutBtn from "./UserLogoutBtn";
import Truncate from "../common/Truncate";

// --
// -- Who is signed in, and the way out. The users portal makes this a link to
// -- /account; there is no account page here yet, so it is display only.
// --
const UserWidget: FC = () => {
  const user = useTypedSelector(getCurrentUser());

  return (
    <div className="flex gap-4 items-center h-full">
      <div className="flex gap-4 h-full justify-between items-center px-4">
        <div className="flex w-[35px] h-[35px] min-w-[35px] bg-gray-400 rounded-lg items-center justify-center text-white font-semibold tracking-wide">
          {getInitialsName(user?.name)}
        </div>
        <div className="grid overflow-hidden">
          <div className="truncate">{user?.name ?? 'Nameless'}</div>
          <div className="truncate opacity-80">
            <Truncate>
              {user?.email ?? ''}
            </Truncate>
          </div>
        </div>
      </div>
      <UserLogoutBtn />
    </div>
  );
};

export default UserWidget;
